import { render, staticRenderFns } from "./CustomerServiceRequests.vue?vue&type=template&id=32b2358c&"
import script from "./CustomerServiceRequests.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceRequests.vue?vue&type=script&lang=js&"
import style0 from "./CustomerServiceRequests.vue?vue&type=style&index=0&id=32b2358c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports